export const developerUsername = ['inn_admin'];

export const cannotAccessList = {
  'PlanList': ['admin'],
  'PlanDetail': ['admin'],
  'AddonList': ['admin'],
  'AddonDetail': ['admin'],
}

export const defaultPage = {
  admin: '/user', // type for corp plus staff
  developer: '/user', // type for developer
}
